import React from "react";
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, } from "@mui/material";

const LoginTermsAndCondition = ({ onAccept }) => {
  return (
    <div className="terms-container">
     
      <p>
        By accepting, you agree to the terms and conditions of our service.
      </p>
      {/* Show terms and conditions text here */}
      <Button onClick={onAccept}>Accept Terms</Button>
    </div>
  );
};

export default LoginTermsAndCondition;
